export enum SlideType {
    AssessmentIntro = "ASSESSMENT_INTRO",
    Complete = "COMPLETE",
    GroupIntro = "GROUP_INTRO",
    Tests = "TESTS",
    Tips = "TIPS",
    Question = "QUESTION",
    Video = "VIDEO",
}
